import monitoring from '../../assets/icons/home/effects/monitoring.svg';
import troubleshooting from '../../assets/icons/home/effects/troubleshooting.svg';
import biz_analysis from '../../assets/icons/home/effects/biz_analysis.svg';
import security from '../../assets/icons/home/effects/security.svg';
import digital_experience from '../../assets/icons/home/effects/dig_experience.svg';
import dev_ops from '../../assets/icons/home/effects/devops.svg';


const features = [
  {
    title: "Мониторинг",
    description: ["SLO (Service Level Objective) — это внутренняя цель, определяющая уровень качества сервиса. Автоматическое отслеживание всей инфраструктуры: гибрид, контейнеры, виртуальные машины, сеть, серверы, хранилище и многое другое"],
    icon: monitoring,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  },
  {
    title: "Траблшутинг",
    description: ["Автоматическое определение корневой причины проблемы/ошибки или аномалий на уровне кода в приложениях и микросервисах"],
    icon: troubleshooting,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  },
  {
    title: "Бизнес-анализ",
    description: ["Мониторинг бизнес-операций и анализ поведения пользователей. Трассировка кода приложений и построение бизнес-аналитики"],
    icon: biz_analysis,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  },
  {
    title: "Безопасность",
    description: ["Мониторинг событий безопасности: сбор и анализ сведений, уязвимостей для обнаружения возможных атак. Анализ типов совершённых атак, лог файлов и кода приложения"],
    icon: security,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  },
  {
    title: "Цифровой опыт",
    description: ["Мониторинг цифрового опыта позволяет отслеживать, как пользователи взаимодействуют с приложением, выявляя узкие места и проблемы в реальном времени"],
    icon: digital_experience,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  },
  {
    title: "DevOps",  
    description: ["Oрганизация работы инструментов DevOps в единую цепочку и автоматизация процессов мониторинга, проверки качества и устранения проблем"],
    icon: dev_ops,
    style: "p-[30px] gap-[12px] bg-gradient-to-r from-[#6082A0] to-[#E55961] rounded-[30px]"
  }
]

function FeatureCard({ title, description, icon, style }) {
  return (
    <div className={`flex flex-col items-start justify-start rounded-xl mb-[40px] w-[390px] lg:h-[390px] ${style} bg-home-features`}>
      
      <div className='flex w-full items-center gap-[10px] lg:flex-col'>
        <div className='lg:w-[100%] flex items-start justify-start'>
            <img src={icon} alt="" className="w-[39px] lg:w-[70px]" />
          </div>
        <div className="flex items-start lg:w-full">
          <h3 className="text-[18px] lg:text-[24px] w-full text-left font-bold bg-clip-text text-[#544A28]">
            {title}
          </h3>
        </div>
      </div>
      
      <div className="text-[#544a28] text-[16px] xl:text-[16px] w-full text-left px-[10px] xl:px-[0px]">{
        description.map((item, index) => (
          <span key={index}>
            {item} 
          </span> 
        ))
      }</div>
    </div>
  );
} 

export default function FeaturesKA() {
  return (
    <div className="w-full max-w-full xl:w-[1440px] flex justify-center items-center">
      <div className="flex flex-col items-center gap-2 xl:gap-[70px] w-full max-w-[360px] lg:max-w-[820px] xl:max-w-[1215px] lg:w-full">

        <div className="md:text-center leading-normal text-[18px] xl:text-[32px] xl:leading-[44.8px] font-bold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text mt-[28px]">
          «Ключ-Астром» — ваш ключ к автоматизации <br className='hidden xl:block'/> и эффективному управлению.
        </div>

        <div className="flex flex flex-wrap justify-center lg:justify-between items-start container mt-[40px] xl:mt-[-10px] mx-auto">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              style={feature.style}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
          

